import { EditorState } from 'draft-js';

var mergeEntityData = function mergeEntityData(editorState, entityKey, data) {
  var newContentState = editorState.getCurrentContent().mergeEntityData(entityKey, data);
  return EditorState.forceSelection(EditorState.push(editorState, newContentState, 'apply-entity'), editorState.getSelection());
};

export default mergeEntityData;


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-modifiers/es/mergeEntityData.js
// module id = 248
// module chunks = 0